import PropTypes from 'prop-types';
import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from 'contexts/AuthContext';
import LoadingScreen from 'components/LoadingScreen';

const AuthGuard = ({ children }) => {
  const { isLoggedIn, isInitialized } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (isInitialized && !isLoggedIn) {
      navigate('/login', { replace: true });
    }
  }, [isLoggedIn, isInitialized, navigate]);

  if (!isInitialized) return <LoadingScreen />;

  return children;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
